import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../reducers';
import { isReceiver } from '../../utils/UserUtils';
import SettingsCustomFieldsContainer from './SettingsCustomFieldsContainer';
import ParentCustomFieldsContainer from '../parentSettings/customFields/ParentCustomFieldsContainer';

const CustomFieldsRouter: React.FC = () => {
  const user = useSelector((state: ApplicationState) => state.user.user);

  // If user is a receiver, show the old component
  // If user is a parent (manufacturer), show the new component
  if (user && isReceiver(user)) {
    return <SettingsCustomFieldsContainer />;
  }

  return <ParentCustomFieldsContainer />;
};

export default CustomFieldsRouter;
